export default __webpack_public_path__ + "locales/el-GR/OAuth.json?hash=fd9f6ced09ade5194635b1faa43eb8f6";